module.exports = __webpack_public_path__ + "img/thumb_32.cc958df2.jpg";